import "./tab.component.css";
import * as XLSX from "xlsx-js-style";
import { useEffect, useState, useMemo, useRef } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconHandStop,
  IconFilter,
  IconSearch,
  IconPlus,
  IconDotsVertical,
  IconSettings,
  IconDownload,
  IconCalendar,
  IconTrash,
  IconView360,
  IconLiveView,
  IconActivity,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Card,
  Collapse,
  Flex,
  Grid,
  Group,
  Input,
  Menu,
  Paper,
  rem,
  ScrollArea,
  Select,
  Tabs,
  Title,
  Tooltip,
} from "@mantine/core";
import { DateInput, DatePickerInput, DateTimePicker } from "@mantine/dates";
import { useClickOutside, useDisclosure, useId } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  getDocTypSelect,
  getEcmClassSelect,
  getOrganizationsSelect,
  getPartnersSelect,
  getProcessDefSelect,
  getUsersSelect,
} from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import PopupStep from "./PopupStep";
import {
  HistoryDocumentModelQuery,
  HistoryFolderModel,
} from "../../model/HistoryFolderModel";
import { ListDocumentHistorySearchModel } from "../../model/BaseSearchModel";
import { useForm } from "@mantine/form";
import {
  pageTable,
  repositorySign,
  styleTable,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { EditProfile } from "../Func/CreateProfile/EditProfile/EditProfile";
import DeleteTableView from "../Func/CreateProfile/DeleteTableView/DeleteTableView";
import { SelectListItem } from "../../model/SelectListItem";
import { useNavigate } from "react-router-dom";
import HistoryProfile from "../Func/CreateProfile/HistoryProfile/HistoryProfile";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { FileReturnModel } from "../../model/FileReturnModel";
import saveAs from "file-saver";
import { BASE_API_SIGN } from "../../_base/_const";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
import { IconEdit } from "@tabler/icons-react";

// Format ngày cho query API theo GIỜ ĐỊA PHƯƠNG (không đổi sang UTC để tránh
// lệch ngày). FromDate lấy đầu ngày (00:00:00), ToDate lấy cuối ngày (23:59:59)
// để bao trọn cả ngày được chọn.
const pad2 = (n: number) => String(n).padStart(2, "0");
const toApiDateTime = (d: Date, endOfDay: boolean) =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${
    endOfDay ? "23:59:59" : "00:00:00"
  }`;

const ForderTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<HistoryDocumentModelQuery[]>([]);
  const [isExporting, setIsExporting] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [openedMenu, setOpenedMenu] = useState(false);
  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [dataUpdated, setDataUpdated] = useState(false);

  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();
  const search: ListDocumentHistorySearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  //
  const dataStatus = [
    { value: "CHO_TAO", label: "Chờ tạo" },
    { value: "DANG_DUYET", label: "Đang duyệt" },
    { value: "DA_DUYET", label: "Đã duyệt" },
    { value: "TU_CHOI", label: "Từ chối" },
  ];
  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const [dataOrganizations, setDataOrganizations] = useState<SelectListItem[]>(
    []
  );
  // const [dateopartners, setpartners] = useState<SelectListItem[]>([]);
  const [dataDocType, setDataDocType] = useState<SelectListItem[]>([]);
  // const [softRaw, setsoftRaw] = useState("");

  // async function getEcmClass() {
  //   const data = await getEcmClassSelect();
  //   if (data && data.length > 0) setecm(data);
  // }

  async function getDataDocType() {
    const data = await getDocTypSelect();
    if (data && data.length > 0) setDataDocType(data);
  }

  // const [status, setStatus] = useState<number>(0);

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListDocumentHistorySearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        DocTypeId: form.getValues().DocTypeId,
        DepartmentId: form.getValues().DepartmentId,
        Status: form.getValues().Status,
        keySearch: form.getValues().keySearch,
        CreateBy: form.getValues().CreateBy,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        FromDate: form.getValues().FromDate,
        ToDate: form.getValues().ToDate,
      };

      const baseUrl = "/api/v1/SubmissionHistory/get-list-document";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date
                ? toApiDateTime(value, key === "ToDate")
                : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<HistoryDocumentModelQuery[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);

        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const ref = useClickOutside(() => setOpenedMenu(false));

  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setDataListUser(data);
  }

  async function getOrganizations() {
    const data = await getOrganizationsSelect();
    if (data && data.length > 0) setDataOrganizations(data);
  }

  const handleEditTable = (ids: string | number) => {
    navigate("/method/folders-edit", {
      state: { id: ids },
    });
  };

  const openModelHistory = (ids: number | null) =>
    modals.openConfirmModal({
      title: <Title order={4}>Lịch sử phê duyệt</Title>,
      size: "100%",
      children: <HistoryProfile ids={ids} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });

  const departmentMap = useMemo(() => {
    const map = new Map<number, string>();
    dataOrganizations.forEach((dapartment) => {
      map.set(Number(dapartment.value), dapartment.text);
    });
    return map;
  }, [dataOrganizations]);

  const usersMap = useMemo(() => {
    const map = new Map<number, string>();
    dataListUser.forEach((user) => {
      map.set(Number(user.value), user.text);
    });
    return map;
  }, [dataListUser]);

  const handleViewTable = (ids: string | number) => {
    modals.openConfirmModal({
      title: <Title order={4}>Sửa hồ sơ</Title>,
      size: "100%",
      children: <EditProfile id={ids} onClose={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const handleDeleteTable = (ids: number) => {
    modals.openConfirmModal({
      title: <Title order={4}>Xóa hồ sơ</Title>,
      children: <DeleteTableView ids={ids} onSearch={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleExportExcel = async () => {
    setIsExporting(true);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    const queryParams: ListDocumentHistorySearchModel = {
      skip: pagination.pageIndex * pagination.pageSize,
      take: pagination.pageSize,
      DocTypeId: form.getValues().DocTypeId,
      DepartmentId: form.getValues().DepartmentId,
      Status: form.getValues().Status,
      keySearch: form.getValues().keySearch,
      CreateBy: form.getValues().CreateBy,
      sort: _softing,
      isOrder: sorting.length > 0 ? sorting[0].desc : true,
      FromDate: form.getValues().FromDate,
      ToDate: form.getValues().ToDate,
    };

    const baseUrl = "/api/v1/SubmissionHistory/get-list-document?isAll=true";
    const queryString = Object.entries(queryParams)
      .reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          const stringValue =
            value instanceof Date
              ? toApiDateTime(value, key === "ToDate")
              : value.toString();
          return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
        }
        return acc;
      }, "")
      .replace(/^&/, "");
    const url = `${baseUrl}${queryString ? `&${queryString}` : ""}`;
    try {
      const response = await repositorySign.get<
        MessageResponse<HistoryDocumentModelQuery[]>
      >(url);
      if (response && response.success && response.data) {
        // Map lại dữ liệu trước khi xuất Excel
        const mappedData = response.data.map((item) => ({
          ...item,
          createName: usersMap.get(item.createBy ?? 0) || "",
          departmentName: departmentMap.get(item.departmentId ?? 0) || "",
        }));
        // Lấy hồ sơ có nhiều bước duyệt nhất làm mốc số cột động
        const maxSteps = mappedData.reduce(
          (max, doc) => Math.max(max, doc.approvalSteps?.length ?? 0),
          0
        );
        const excelData = convertDataToExcel(mappedData, maxSteps);
        const ws = XLSX.utils.json_to_sheet(excelData);
        // Căn độ rộng từng cột theo nội dung để bảng cân đối, không bị cắt chữ
        const headerKeys = Object.keys(excelData[0] ?? {});
        ws["!cols"] = headerKeys.map((key) => {
          const maxLen = excelData.reduce((m, r) => {
            const v = (r as Record<string, any>)[key];
            return Math.max(m, v == null ? 0 : String(v).length);
          }, key.length);
          return { wch: Math.min(Math.max(maxLen + 2, 12), 40) };
        });

        // Style bảng: header in đậm + nền xanh chữ trắng, viền mảnh toàn bảng,
        // căn giữa các cột ngày cho cân đối (xlsx-js-style).
        const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
        const thin = { style: "thin", color: { rgb: "D9D9D9" } };
        for (let R = range.s.r; R <= range.e.r; R++) {
          for (let C = range.s.c; C <= range.e.c; C++) {
            const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
            const cell = (ws as Record<string, any>)[cellRef];
            if (!cell) continue;
            const isHeader = R === 0;
            const label = headerKeys[C] ?? "";
            const isDateCol = label.startsWith("Ngày");
            cell.s = {
              font: {
                name: "Calibri",
                sz: 11,
                bold: isHeader,
                color: { rgb: isHeader ? "FFFFFF" : "212529" },
              },
              fill: isHeader
                ? { patternType: "solid", fgColor: { rgb: "1971C2" } }
                : undefined,
              alignment: {
                vertical: "center",
                horizontal: isHeader
                  ? "center"
                  : isDateCol
                  ? "center"
                  : "left",
                wrapText: false,
              },
              border: { top: thin, bottom: thin, left: thin, right: thin },
            };
          }
        }
        ws["!rows"] = [{ hpt: 22 }];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Danh sách");
        const now = new Date();
        const fileName =
          "lich-su-ho-so-" +
          now.getFullYear() +
          ("0" + (now.getMonth() + 1)).slice(-2) +
          ("0" + now.getDate()).slice(-2) +
          "-" +
          ("0" + now.getHours()).slice(-2) +
          ("0" + now.getMinutes()).slice(-2) +
          ("0" + now.getSeconds()).slice(-2) +
          ".xlsx";
        XLSX.writeFile(wb, fileName);
      } else {
        NotificationExtension.Fails("Không có dữ liệu để xuất Excel!");
      }
    } catch (error) {
      NotificationExtension.Fails("Lỗi xuất Excel!");
    } finally {
      setIsExporting(false);
    }
  };

  const excelHeaders = [
    { key: "setupSignStepId", label: "Id" },
    { key: "docCode", label: "Mã hồ sơ" },
    { key: "status", label: "Trạng thái" },
    { key: "docName", label: "Tên hồ sơ" },
    { key: "docTypeName", label: "Loại hồ sơ" },
    { key: "departmentName", label: "Đơn vị" },
    { key: "createDate", label: "Ngày tạo" },
    { key: "createName", label: "Người tạo" },
    // Thêm các trường khác nếu cần
  ];

  function convertDataToExcel(
    data: HistoryDocumentModelQuery[],
    maxSteps: number = 0
  ) {
    return data.map((item) => {
      const row: Record<string, any> = {};
      excelHeaders.forEach((header) => {
        // Nếu cần format ngày, có thể xử lý tại đây
        if (header.key === "createDate") {
          const value = (item as any)[header.key];
          row[header.label] = formatDateTransfer(value);
        } else if (header.key === "status") {
          const value = (item as any)[header.key];
          row[header.label] = getTextColorStatus(value ?? "").text;
        } else {
          row[header.label] = (item as any)[header.key];
        }
      });

      // Cột động: "Người duyệt X" / "Ngày duyệt X" theo từng bước phê duyệt.
      // Hồ sơ ít bước hơn thì các cột dư để trống.
      const steps = item.approvalSteps ?? [];
      for (let i = 0; i < maxSteps; i++) {
        const step = steps[i];
        const approverId = step?.approverId;
        const approverName = approverId
          ? usersMap.get(Number(approverId)) || approverId
          : "";
        row[`Người duyệt ${i + 1}`] = approverName;
        row[`Ngày duyệt ${i + 1}`] = step?.approvalDate
          ? formatDateTransfer(step.approvalDate)
          : "";
      }

      return row;
    });
  }

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    getUser();
    getOrganizations();

    // getEcmClass();
    // getPartners();
  }, []);
  useEffect(() => {
    if (dataUpdated) {
      const updatedData = data.map((item) => ({
        ...item,
        createName: usersMap.get(item.createBy ?? 0) || "",
        departmentName: departmentMap.get(item.departmentId ?? 0) || "",
      }));
      setData(updatedData);
      setDataUpdated(false);
    }
  }, [data, dataUpdated, usersMap, departmentMap]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (170 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openHistoryFlow = (id: number) =>
    modals.openConfirmModal({
      title: "",
      children: (
        <>
          <PopupStep id={id}></PopupStep>
        </>
      ),
      labels: { confirm: "Đóng", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      cancelProps: { display: "none" },
      size: "70%",
      scrollAreaComponent: ScrollArea.Autosize,
    });

  function progessTemplate(props: HistoryDocumentModelQuery): any {
    return (
      <>
        <Tooltip label="Xem thông tin">
          <ActionIcon
            onClick={() => {
              navigate("/method/folders-edit", {
                state: { id: props.docId },
              });
            }}
            variant="light"
            aria-label="Settings"
            color="blue"
          >
            <IconSearch size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Lịch sử công việc">
          <ActionIcon
            onClick={(e) => {
              openModelHistory(props.docId);
            }}
            variant="light"
            aria-label="Settings"
            color="cyan"
          >
            <IconHistory size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>

        <Tooltip label="Tải về">
          <ActionIcon
            onClick={async () => {
              try {
                // Thay URL_API của bạn vào đây
                const _url =
                  BASE_API_SIGN +
                  "/api/v1/signpage/get-files-documnet-v2?id=" +
                  props.docId;
                const response = await fetch(_url, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/zip",
                  },
                });

                if (!response.ok) {
                  throw new Error("Failed to download file");
                }
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const _name = new Date().toISOString().slice(0, 10);
                let filename = props.docName + "-" + _name + ".zip"; // Tên mặc định nếu không có header
                const link = document.createElement("a");
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
              } catch (error) {
                NotificationExtension.Fails("Error downloading the file !");
              }
            }}
            variant="light"
            aria-label="Settings"
            color="grape"
          >
            <IconDownload size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="sửa">
          <ActionIcon
            onClick={async () => {
              await handleEditTable(props.docId);
            }}
            variant="light"
            aria-label="Settings"
            color="blue"
          >
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Xóa">
          <ActionIcon
            onClick={async () => {
              await handleDeleteTable(props.docId);
            }}
            variant="light"
            aria-label="Settings"
            color="red"
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  function getTextColorStatus(text: string) {
    switch (text.trim()) {
      case "DANG_DUYET":
        return {
          color: "blue",
          text: "Đang duyệt",
        };
      case "DA_DUYET":
        return {
          color: "teal",
          text: "Đã duyệt",
        };
      case "TU_CHOI":
        return {
          color: "red",
          text: "Từ chối",
        };
      //  case "Hủy duyệt":
      default:
        return {
          color: "orange",
          text: "Chờ tạo",
        };
    }
  }

  const columns = useMemo<MRT_ColumnDef<HistoryDocumentModelQuery>[]>(
    () => [
      {
        accessorKey: "setupSignStepId",
        header: "Id",
      },
      {
        accessorKey: "docCode",
        header: "Mã hồ sơ",
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="light"
              color={
                getTextColorStatus(renderedCellValue?.toString() ?? "").color
              }
            >
              {getTextColorStatus(renderedCellValue?.toString() ?? "").text}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "docName",
        header: "Tên hồ sơ",
      },

      {
        accessorKey: "docTypeName",
        header: "Loại hồ sơ",
      },
      {
        accessorKey: "departmentName",
        header: "Đơn vị",
        enableSorting: false,
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createName",
        header: "Người tạo",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: () => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row?.setupSignStepId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: [
        //   "STT",
        //   "mrt-row-select",
        //   "mrt-row-expand",
        //   "orderNumber",
        //   "orderStatus",
        // ],
        right: ["action"],
      },
      columnVisibility: { setupSignStepId: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: () => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              loading={isExporting}
              onClick={handleExportExcel}
            >
              Tải về
            </Button>
          </Flex>
        </Flex>
        <form>
          <Grid gutter="xs">
            <Grid.Col span={_span}>
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Loại hồ sơ"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataDocType.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataDocType || dataDocType.length < 1) {
                    await getDataDocType();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`DocTypeId`)}
                {...form.getInputProps("DocTypeId")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Đơn vị"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataOrganizations.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`DepartmentId`)}
                {...form.getInputProps("DepartmentId")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Người tạo"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`CreateBy`)}
                {...form.getInputProps("CreateBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Trạng thái"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataStatus.map((item) => {
                  return {
                    label: item.label ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`Status`)}
                {...form.getInputProps("Status")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                key={form.key(`FromDate`)}
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                placeholder="Chọn..."
                label="Từ ngày"
                {...form.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                key={form.key(`ToDate`)}
                placeholder="Chọn..."
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                label="Đến ngày"
                {...form.getInputProps("ToDate")}
                clearable
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              {" "}
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
                mt={"25px"}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ForderTable;
